import React, { Component } from "react";

export default class Input extends Component {
  state = { isInputTouched: false, isInputFocused: false };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = event => {
    if (this.input) {
      if (this.input.contains(event.target)) {
        this.setState({ isInputFocused: true });
        if (this.input.querySelector) {
          this.input.querySelector("input").focus();
        }
      } else {
        this.setState({ isInputFocused: false });
      }
    }
  };
  onFocusHandler = event => {
    const { isInputTouched } = this.state;
    if (!isInputTouched) {
      this.setState({ isInputTouched: true });
    }
  };
  render() {
    const { isInputFocused, isInputTouched } = this.state;
    const {
      placeholder,
      className,
      value,
      disabled,
      readOnly,
      onChange,
      label,
      onClear,
      error,
      type = "text",
      info
    } = this.props;
    let _classes = ["form-group", "form-group-custom", "form-control-clear"];
    if (isInputFocused) {
      _classes.push("active");
    }
    if (!label) {
      _classes.push("form-control-clear-no-head");
    }
    return (
      <div
        className={_classes.join(" ")}
        ref={element => (this.input = element)}
      >
        {label ? <label>{label}</label> : null}
        <div class="form-control-clear-wrap">
          <input
            type={type}
            className={
              className
                ? ["form-control"].concat(className).join(" ")
                : "form-control"
            }
            value={value}
            disabled={disabled}
            readOnly={readOnly}
            onChange={event => {
              event.preventDefault();
              onChange(event.target.value);
            }}
            placeholder={placeholder}
            onFocus={this.onFocusHandler}
          />
          {readOnly || disabled ? null : onClear ? (
            <a class="form-control-clear-button" onClick={onClear}>
              <span class="glyphicon glyphicon-remove" />
            </a>
          ) : null}
        </div>
        {error && isInputTouched ? (
          <span className="help-block">{error}</span>
        ) : info ? (
          <span className="help-block">{info}</span>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Input/index.js